import { SectionCard } from '@/components/SectionCard'
import { Button } from '@/components/ui/button'
import { Printer, QrCode } from 'lucide-react'

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generateQRCode, printQRCodes } from '../utils/qrcode'
type SingleQRCardProps = {
  title: string
  subtitle?: string
  url: string
  onPrint?: () => void
}

export function SingleQRCard({ title, subtitle, url, onPrint }: SingleQRCardProps) {
  const { t } = useTranslation()
  const [qr, setQr] = useState('')

  useEffect(() => {
    generateQRCode(url).then(setQr)
  }, [url])

  async function handlePrint() {
    await printQRCodes({
      items: [
        {
          url,
          title,
          subtitle,
        },
      ],
    })
  }

  return (
    <SectionCard noCardTitle cardClass="bg-secondary/30">
      <div className="flex flex-col items-center gap-4 p-4">
        <div className="rounded-xl bg-white p-3 shadow-sm">
          {qr ? <img src={qr} width={120} /> : <QrCode className="size-8" />}
        </div>

        <div className="text-center">
          <div className="text-base font-semibold">{title}</div>

          {subtitle && <div className="text-sm text-muted-foreground">{subtitle}</div>}
        </div>

        {onPrint && (
          <Button onClick={handlePrint}>
            <Printer className="mr-2 size-4" />
            {t('common.qrcodeManager.printQr')}
          </Button>
        )}
      </div>
    </SectionCard>
  )
}
